import { Search, X } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export function SearchFilter({ 
  searchValue, 
  onSearchChange, 
  searchPlaceholder = 'Search...',
  filters = [],
  onReset
}) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-4">
      {/* Search */}
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
        <Input
          type="text"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 bg-slate-900 border-slate-700 text-slate-300 placeholder:text-slate-500"
          data-testid="search-input"
        />
      </div>

      {/* Filters */}
      {filters.map((filter) => (
        <Select 
          key={filter.key} 
          value={filter.value} 
          onValueChange={filter.onChange}
        >
          <SelectTrigger 
            className="w-[150px] bg-slate-900 border-slate-700 text-slate-300"
            data-testid={`filter-${filter.key}`}
          >
            <SelectValue placeholder={filter.placeholder} />
          </SelectTrigger>
          <SelectContent className="bg-slate-900 border-slate-700">
            {filter.options.map((option) => (
              <SelectItem 
                key={option.value} 
                value={option.value}
                className="text-slate-300 focus:bg-slate-800 focus:text-white"
              >
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ))}

      {/* Reset */}
      {onReset && (
        <Button
          variant="ghost"
          onClick={onReset}
          className="text-slate-400 hover:text-white"
          data-testid="reset-filters-btn"
        >
          <X className="w-4 h-4 mr-1" />
          Reset
        </Button>
      )}
    </div>
  );
}
